import React, { useMemo } from 'react';
import { Translate, TranslateScope } from '@pegasus/translation';
import { useConfig } from '@browsing/config';
import { ResponsiveSlider, SliderItem } from '@lux/slider';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { ArticleCompactInlineCard } from '@browsing/components';
import { useTrackViewItemList, trackSelectItem, trackSelectContent } from '@browsing/tracking';
import { CatalogType, isModifierKeyPressed, NavigationSourceType } from '@browsing/utils';
import { useNavigateToPDP } from '@browsing/hooks';
import * as S from './styles';
export var Carousel = function (_a) {
    var carouselItems = _a.carouselItems, isInView = _a.isInView;
    var config = useConfig();
    var slicedCarouselItems = useMemo(function () { return (Array.isArray(carouselItems) ? carouselItems.slice(0, 9) : []); }, [carouselItems]);
    var _b = useNavigateToPDP(), navigateToPDP = _b.navigateToPDP, getPDPURLPath = _b.getPDPURLPath;
    useTrackViewItemList({
        items: slicedCarouselItems,
        payload: {
            element: 'tp4u',
            context: 'tp4u',
            item_list_name: 'tp4u',
        },
        itemMapper: function () { return ({
            item_list_name: 'tp4u',
            recommended: 'article_recommendation',
        }); },
        triggerCondition: slicedCarouselItems.length !== 0 && isInView,
    });
    var getOnArticleClick = function (article, idx) { return function (e) {
        if (config.isEnabled('ga4')) {
            trackSelectItem({
                element: 'tp4u',
                itemListName: 'tp4u',
                item: article,
            }, {
                customMapper: function () { return ({ index: idx }); },
            });
        }
        // Prevent clicks on LUX <ArticleCard/>, whose children are wrapped in a link, from navigating to the PDP.
        e.preventDefault();
        navigateToPDP({
            queryParams: {
                campaignId: article.campaignIdentifier,
                configSku: article.sku,
                navigationSource: NavigationSourceType.TopPicks,
                catalogType: CatalogType.TopPicks,
            },
            shouldOpenInNewTab: isModifierKeyPressed(e),
        });
    }; };
    // Pass `pdpURLPath` to <ArticleCard/>'s link for accessibility/robustness, even though we prevent its
    // default behavior. e.g. the user might right-click the link, which is not handled here.
    var getArticleURLPath = function (article) {
        return getPDPURLPath({
            queryParams: {
                campaignId: article.campaignIdentifier,
                configSku: article.sku,
                navigationSource: NavigationSourceType.TopPicks,
                catalogType: CatalogType.TopPicks,
            },
        });
    };
    var trackLastSeeAllClick = function () {
        trackSelectContent('tp4u_banner', 'click', { contentId: 'see_all_last' });
    };
    return (React.createElement(TranslateScope, { path: "myLounge.recommendations" },
        React.createElement(ResponsiveSlider, { visibleItems: 2.2, visibleItemsXs: 3, visibleItemsMd: 3.2, visibleItemsLg: 4.2, "aria-labelledby": "top-picks-headline", 
            // TODO: A11Y - Provide localised keys.
            previousSlideLabel: "", 
            // TODO: A11Y - Provide localised keys.
            nextSlideLabel: "", withOverflow: true },
            slicedCarouselItems.map(function (article, index) {
                return (React.createElement(SliderItem, { key: article.sku },
                    React.createElement(ArticleCompactInlineCard, { brand: article.brand, onClick: getOnArticleClick(article, index), pdpURLPath: getArticleURLPath(article), media: article.media, nameCategoryTag: article.nameCategoryTag, nameColor: article.nameColor, nameShop: article.nameShop, price: article.price, specialPrice: article.specialPrice })));
            }),
            React.createElement(SliderItem, null,
                React.createElement(TranslateScope, { path: "myLounge.TP4U" },
                    React.createElement(S.LastSeeAll, { onClick: trackLastSeeAllClick, href: "/campaigns/top-picks/articles" },
                        React.createElement(Button, { as: "span", buttonType: ButtonType.tertiary, color: ButtonColor.dark },
                            React.createElement(Translate, { message: "cta", raw: true }))))))));
};
